/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Eye Slash Outline Icon component.
 */
export const SystemEyeSlashOutlineIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M4.51416 3.76562L19.4863 20.2349' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M14.5175 14.7707C13.7829 15.4384 12.8132 15.7869 11.8217 15.7397C10.8302 15.6924 9.89799 15.2532 9.23026 14.5187C8.56252 13.7842 8.2139 12.8145 8.26107 11.823C8.30824 10.8314 8.74735 9.89925 9.4818 9.23145' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M6.9464 6.44141C3.13139 8.37333 1.51953 12.0004 1.51953 12.0004C1.51953 12.0004 4.51395 18.7371 12 18.7371C13.754 18.7511 15.4861 18.3471 17.0529 17.5586' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M19.5434 15.8458C21.5835 14.0185 22.4808 11.9999 22.4808 11.9999C22.4808 11.9999 19.4863 5.26173 12.0003 5.26173C11.3519 5.26067 10.7046 5.31339 10.0649 5.41933' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M12.7046 8.32324C13.5001 8.47601 14.2247 8.8826 14.7696 9.48202C15.3146 10.0814 15.6504 10.8414 15.7269 11.6479' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default SystemEyeSlashOutlineIcon;
